import state from './moduleActivityState.js'
import mutations from './moduleActivityMutations.js'
import actions from './moduleActivityActions.js'
import getters from './moduleActivityGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
